import React from 'react';
import PropTypes from 'prop-types';
import './Divider.scss';

/**
 * Horizontal rule for layout (replaces ad-hoc `.separator` divs).
 * Default is presentational; set `decorative={false}` for a landmark separator.
 */
const Divider = ({ className = '', decorative = true, ...rest }) => (
  <div
    className={['ds-divider', className].filter(Boolean).join(' ')}
    role={decorative ? 'presentation' : 'separator'}
    aria-hidden={decorative ? true : undefined}
    {...rest}
  />
);

Divider.propTypes = {
  className: PropTypes.string,
  decorative: PropTypes.bool,
};

Divider.defaultProps = {
  className: '',
  decorative: true,
};

export default Divider;
